import { render, staticRenderFns } from "./entry-info-team-detail.vue?vue&type=template&id=5274d462&scoped=true&"
import script from "./entry-info-team-detail.vue?vue&type=script&lang=js&"
export * from "./entry-info-team-detail.vue?vue&type=script&lang=js&"
import style0 from "./entry-info-team-detail.vue?vue&type=style&index=0&id=5274d462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5274d462",
  null
  
)

export default component.exports